import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import formService from "../../services/forms/form.service";
import adminService from "../../services/admin/admin.services";
import { AnketRequestDto } from "../../services/forms/form.dto";
import { VideoDto } from "../../services/admin/admin.dto";
import { useToast } from "../../utils/toast";
import { InputTextarea } from "primereact/inputtextarea";
import ProtokolFirmalarComponent from "../../components/ProtokolFirmalarComponent";
import VideoComponent from "../../components/VideoComponent";

const OsbukBulten = () => {
  const toast = useToast();
  const [answer, setAnswer] = useState<string>("");
  const [videos, setVideos] = useState<VideoDto[]>([]);
  const [selectedVideo, setSelectedVideo] = useState<VideoDto | null>(null);
  //   const [videoArchive, setVideoArchive] = useState<VideoComponentArsivProps[]>([
  //     { videoUrl: "https://www.youtube.com/watch?v=d3kwhP3OMPM", header: "Bülten 1 (Aralık 2024)" },
  //     { videoUrl: "https://youtu.be/E7tFzh2rODU", header: "Bülten 2 (Ocak 2025)" }
  //   ]);
  useEffect(() => {
    loadVideos();
  }, []);

  const loadVideos = async () => {
    try {
      const response = await adminService.getVideos("BULTEN");
      if (response?.result?.data) {
        setVideos(response.result.data);
        // İlk video varsayılan olarak seçili olsun
        if (response.result.data.length > 0) {
          setSelectedVideo(response.result.data[0]);
        }
      }
    } catch (error) {
      console.error("Error loading videos:", error);
      toast.show("Video verilerini yüklerken bir hata oluştu.", "error");
    }
  };

  const handleVideoSelect = (video: VideoDto) => {
    setSelectedVideo(video);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleSubmit = async () => {
    try {
      if (answer === "") {
        toast.show("Lütfen formu doldurunuz.", "error");
        return;
      }
      const dto: AnketRequestDto = {
        result1: answer ?? ""
      };

      formService
        .haberAnket(dto)
        .then((res) => {
          if (res?.result?.error === null) {
            toast.show("Form başarıyla kaydedildi!", "success");
          } else {
            toast.show("Form gönderiminde hata oluştu.", "error");
          }
        })
        .catch((error) => {
          toast.show("Sunucu hatası: " + error.message, "error");
        });
    } catch (error) {
      //toast.show("Bir hata oluştu. Lütfen tekrar deneyin.", "error");
    }
  };

  return (
    <>
      {selectedVideo && (
        <VideoComponent videoUrl={selectedVideo.video_url} header={selectedVideo.title} autoplay={true} />
      )}

      <div className="card">
        <div className="w-full surface-card">
          <div className="text-center mb-5">
            <div className="text-900 text-3xl font-medium mb-3">OSBÜK Bülten Video Arşivi</div>
          </div>
        </div>
        <div className="justify-content-center">
          <div className="grid">
            {videos.map((video) => (
              <div className="col-12 md:col-6 lg:col-4" key={video.id}>
                <div
                  className="cursor-pointer"
                  onClick={() => handleVideoSelect(video)}
                  style={{
                    border: selectedVideo?.id === video.id ? "2px solid var(--primary-color)" : "none",
                    borderRadius: "4px",
                    padding: "8px"
                  }}
                >
                  <div className="relative">
                    <img
                      src={`https://img.youtube.com/vi/${video.video_url.split("v=")[1]}/mqdefault.jpg`}
                      alt={video.title}
                      style={{ width: "100%", borderRadius: "4px" }}
                    />
                    <div className="absolute bottom-0 left-0 right-0 p-3 bg-black-alpha-50">
                      <h3 className="text-white m-0 text-lg">{video.title}</h3>
                    </div>
                    <div className="absolute top-50 left-50 transform-center">
                      <i className="pi pi-play-circle text-white text-4xl"></i>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="card">
        <div className="w-full surface-card">
          <div className="text-center mb-5">
            <div className="text-900 text-3xl font-medium mb-3">OSBÜK Bülten Anketi</div>
          </div>
        </div>

        <h5 className="mb-4 font-medium">Bültenimizde hangi konulara yer vermemizi istersiniz?</h5>
        <div className="flex justify-content-center w-full">
          <InputTextarea
            value={answer}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setAnswer(e.target.value)}
            rows={5}
            cols={30}
            style={{ width: "100%" }}
          />
        </div>

        <div className="m-2 md:m-3" style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button label="Kaydet" onClick={handleSubmit} />
        </div>
      </div>

      <ProtokolFirmalarComponent />
    </>
  );
};

export default OsbukBulten;
